import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}
const defaultDetailData = {
  link: {
    active: false,
    type: 'outlink',
    url: langValue(),
    pageId: '',
    productId: '',
    target: false
  },
  background: {
    active: false,
    value: '',
    size: 'auto',
    repeat: 'no-repeat',
    position: '50% 50%',
    color: 'rgba(255, 255, 255, 1)'
  },
  border: {
    active: false,
    style: 'solid',
    color: 'rgba(0, 0, 0, 1)',
    height: 1,
  },
  padding: { // 0: 0, 15: 기본(15px), 30: 넓게(30px)
    active: false,
    tb: '0',
    lr: '0'
  },
  text: {
    active: false,
    color: 'rgba(62, 62, 62, 1)'
  },
  color: {
    active: false,
    color: 'rgba(62, 62, 62, 1)'
  },
  colorHex: {
    active: false,
    color: '#000000'
  },
  qrcode: {
    type: 'outlink',
    url: langValue(),
    pageId: '',
    productId: '',
    target: false
  },
  qrcodeSize: {
    size: '256'
  },
  qrcodeExpired: {
    isActive: false,
    day: 1
  },
  smartkey: {
    remotekey: false,
    size: 32,
    align: 'center'
  },
  remotekey: {
    margin: '15',
    size: '50',
    img: ''
  },
  smartvoice: {
    id: ''
  },
  upload: {
    active: false,
    type: 'image',
    files: [],
    count: 5,
    previewType: 'image',
    label: langValue(),
    labelValue: ''
  },
  radius: {
    active: false,
    tl: '',
    tr: '',
    br: '',
    bl: ''
  }
}
export default defaultDetailData
